import React from 'react';
const items = ['🔥 50% OFF por tiempo limitado', '•', '🎁 4 bonos de regalo incluidos', '•', '⚡ Acceso inmediato tras tu compra', '•'];
function MarqueeTrack() {
  return <div className="flex items-center shrink-0" data-id="element-123">
      {items.map((item, i) => <span key={i} className={`shrink-0 text-[#0a0e17] font-bold uppercase tracking-wide inline-block ${item === '•' ? 'mx-3 text-[#0a0e17]/40 text-xs' : 'mx-3 text-xs sm:text-sm'}`} data-id="element-124">
          {item}
        </span>)}
    </div>;
}
export function PromoBar() {
  return <div className="w-full bg-[#d4a853] overflow-hidden py-2.5 relative" data-id="element-125">
      <div className="flex animate-marquee-seamless whitespace-nowrap" data-id="element-126">
        <MarqueeTrack data-id="element-127" />
        <MarqueeTrack data-id="element-128" />
        <MarqueeTrack data-id="element-129" />
        <MarqueeTrack data-id="element-130" />
      </div>
    </div>;
}